import './App.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { Home } from './pages'
import { NotFound } from './pages/404'
import { NavBar } from './components/Navbar'
import { Success } from './pages/success'
import { Footer } from './components/Footer'
import { Unsubscribe } from './pages/unsubscribe'
import { UnsubscribeSuccess } from './pages/unsubscribe-success'
// import { Error } from './pages/error'
// import { Expired } from './pages/expired'
// import { Closed } from './pages/closed'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <NavBar />
      </header>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/success" element={<Success />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/unsubscribe/success" element={<UnsubscribeSuccess />} />
          {/* <Route path="/success" element={<Success />} /> */}
          {/* <Route path="/failure" element={<Error />} /> */}
          {/* <Route path="/expired" element={<Expired />} /> */}
        </Routes>
      </Router>
      <Footer />
    </div>
  )
}

export default App
